import React from 'react'

export const Users = () => {
    return (
        <div>
            <h1>Desde users</h1>
        </div>
    )
}
